export const TRUCKS_ACTIONS_TYPES = {
	SET_TRUCKS_LOADS: "SET_TRUCKS_LOADS",
	SET_ROMANEIOS_LOAD: "SET_ROMANEIOS_LOAD"
};

// export const UNITS_OP = ["ubs", "diamante", "ouroVerde"];

export const UNITS_OP = [
	{ title: "ubs", description: "UBS" },
	{ title: "diamante", description: "Diamante" },
	{ title: "bencaoDeDeus", description: "Benção De Deus" },
	{ title: "lagoVerde", description: "Lago Verde" },
	{ title: "eldorado", description: "Eldorado" },
	{ title: "campoGuapo", description: "Campo Guapo" }
	// { title: "ouroVerde", description: "Ouro Verde" }
];
